// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66098933","453":"a1d8aff5","455":"d6acbc0c"}[chunkId] + ".chunk.js";
};